import React from "react";

const FireIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M5.9999 10.8002C7.9883 10.8002 9.5999 9.6002 9.5999 7.5002C9.5999 6.6002 9.2999 5.1002 8.0999 3.9002C8.2499 4.8002 7.3499 5.1002 7.3499 5.1002C7.7999 3.6002 6.5999 1.5002 4.7999 1.2002C5.0141 2.4002 5.0999 3.6002 3.5999 4.8002C2.8499 5.4002 2.3999 6.4376 2.3999 7.5002C2.3999 9.6002 4.0115 10.8002 5.9999 10.8002ZM5.9999 10.2002C5.0057 10.2002 4.1999 9.6002 4.1999 8.5502C4.1999 8.1002 4.3499 7.3502 4.9499 6.7502C4.8749 7.2002 5.3999 7.5002 5.3999 7.5002C5.1749 6.7502 5.6999 5.5502 6.5999 5.4002C6.4925 6.0002 6.4499 6.6002 7.1999 7.2002C7.5749 7.5002 7.7999 8.0186 7.7999 8.5502C7.7999 9.6002 6.9941 10.2002 5.9999 10.2002Z"
        fill="white"
      />
    </svg>
  );
};

export default FireIcon;
